export default __webpack_public_path__ + "static/media/error.a76adacf.svg";